import SupabaseService from "./utils/supabaseClient";

export const dbKeys={
job_location:"walkInLocation",
job_title:"walkInTitle",
employer_name:"companyName",
job_description:"walkInDescription",
job_employment_type:"employmentType"
}
const rpc = {
  get_locations: "get_locations",
  get_job_types: "get_job_types",
  get_industries: "get_industries",
};
export const f_list = [
  {
    no: 1,
    message: "Nearby Walk-In Listings",
  },
  {
    no: 2,
    message: "Personalized Skill Recommendations",
  },
  {
    no: 3,
    message: "View Map Location",
  },
  {
    no: 4,
    message: "Simplified Navigation",
  },
];

export const jobFilters = [
  {
    heading: "Job Type",
    name: dbKeys.job_employment_type,
    list: await SupabaseService.fetchActiveFilters(rpc.get_job_types),
  },
  {
    heading: "Location",
    name:dbKeys.job_location,
    list: await SupabaseService.fetchActiveFilters(rpc.get_locations),
  },
];
export const path = {
  landingPage: "/",
  searchPagelink: "search",
  aboutus:"/aboutus",
  terms:"/terms",
  privacypolicy:"/privacypolicy",
  copyright:"/copyrights",
  contactus:"/contact",
  notfound:"*",
  searchPage: (page = 1, limit = 8, filters) => {
    let url = `search?page=${page}&limit=${limit}`;
    filters &&
      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          url += `&${key}=${encodeURIComponent(value)}`;
        }
      });
    return url;
  },
  wakinDetialsPage: (id) => `/walkin?id=${id}`,
};

export const postWalkInLabelNames = {
  walkInTitle: "WalkIn Title",
  companyName: "Company Name",
  walkInLocation: "WalkIn Location",
  interviewDate: "Interview Date",
  interviewTime: "Interview Time",
  mapLocationLink: "Map location link",
  experience: "Experience",
  industryType: "Industry type",
  employmentType: "Employment type",
  walkInCategory: "WalkIn category",
  walkInDescription: "WalkIn description",
  email: "Email Address",
  contactNumber: "Contact Number",
};
export const isRequiredString = (fieldName) => {
  return `${fieldName} is required`;
};
export const industryTypes = [
  { title: "Information Technology (IT) Services", id: 1 },
  { title: "Software Development", id: 2 },
  { title: "Data Analytics & AI", id: 3 },
  { title: "Cybersecurity", id: 4 },
  { title: "IT Hardware & Networking", id: 5 },
  { title: "Hospitals and Clinics", id: 6 },
  { title: "Pharmaceutical Manufacturing", id: 7 },
  { title: "Medical Equipment & Supplies", id: 8 },
  { title: "Research and Development", id: 9 },
  { title: "Retail Chains (Fashion, Groceries, Electronics)", id: 10 },
  { title: "E-commerce Platforms", id: 11 },
  { title: "Logistics and Warehousing", id: 12 },
  { title: "Banking and Financial Services", id: 13 },
  { title: "Insurance Sales and Support", id: 14 },
  { title: "Hotels and Resorts", id: 15 },
  { title: "Travel Agencies", id: 16 },
  { title: "Food and Beverage (Restaurants, Cafes)", id: 17 },
  { title: "Automotive Manufacturing", id: 18 },
  { title: "Electronics and Appliances", id: 19 },
  { title: "Consumer Goods", id: 20 },
  { title: "Real Estate and Property Management", id: 21 },
  { title: "Civil Engineering and Construction Firms", id: 22 },
  { title: "Schools and Colleges", id: 23 },
  { title: "EdTech Companies", id: 24 },
  { title: "Coaching Institutes", id: 25 },
  { title: "Network Services and Providers", id: 26 },
  { title: "Call Centers and Customer Support", id: 27 },
  { title: "Broadcasting and Film Production", id: 28 },
  { title: "Digital Marketing and Content Creation", id: 29 },
  { title: "Supply Chain Management", id: 30 },
  { title: "Delivery Services (Food, Goods, etc.)", id: 31 },
  { title: "Cab Services and Public Transport", id: 32 },
  { title: "Public Sector Undertakings", id: 33 },
  { title: "Utility Services", id: 34 },
  { title: "Renewable Energy (Solar, Wind, etc.)", id: 35 },
  { title: "Electric Vehicle Manufacturing", id: 36 },
  { title: "Gaming and Esports", id: 37 },
  { title: "Event Management", id: 38 },
  { title: "Fitness and Wellness (Gyms, Yoga Studios)", id: 39 },
  { title: "Non-Profit and NGOs", id: 40 },
];

export const walkInCategories = [
  { title: "Technology & IT", id: 1 },
  { title: "Healthcare & Biotechnology", id: 2 },
  { title: "Retail & E-Commerce", id: 3 },
  { title: "Banking, Finance & Insurance", id: 4 },
  { title: "Hospitality & Tourism", id: 5 },
  { title: "Manufacturing & Production", id: 6 },
  { title: "Construction & Real Estate", id: 7 },
  { title: "Education & Training", id: 8 },
  { title: "Telecommunication", id: 9 },
  { title: "Media & Entertainment", id: 10 },
  { title: "Transportation & Logistics", id: 11 },
  { title: "Government & Public Services", id: 12 },
  { title: "Emerging Industries", id: 13 },
  { title: "Miscellaneous", id: 14 },
];

export const employmentTypes = [
  { title: "Full-Time", id: 1 },
  { title: "Part-Time", id: 2 },
  { title: "Contract", id: 3 },
  { title: "Internship", id: 4 },
  { title: "Temporary", id: 5 },
  { title: "Freelance", id: 6 },
  { title: "Volunteer", id: 7 },
  { title: "Remote", id: 8 },
];

export const walkInExperiences = [
  { title: "1 Year", id: 0 },
  { title: "2 Years", id: 1 },
  { title: "3 Years", id: 2 },
  { title: "4 Years", id: 3 },
  { title: "More than 4 Years", id: 4 },
];


export const tableName= {
  postWalkin:"postWalkin"
}


export const postWalkInSuccessMsg="Walk-in Post Added Successfully"